import { motion } from 'motion/react'

import { m } from '~/paraglide/messages.js'
import { useParagraphReveal } from '~/components/use-paragraph-reveal'

const revealSteps = [
  { selector: '[data-a="1"]', at: 2.4 },
  { selector: '[data-a="2"]', at: 3.4 },
  { selector: '[data-a="3"]', at: 4.4 },
  { selector: '[data-a="4"]', at: 5.4 },
] as const

export function Page1Content({
  skipNonce,
  onRevealsComplete,
}: {
  skipNonce: number
  onRevealsComplete?: () => void
}) {
  const { scope } = useParagraphReveal({
    steps: revealSteps,
    skipNonce,
    onComplete: onRevealsComplete,
  })

  return (
    <motion.div
      ref={scope}
      className="flex w-full flex-col items-center gap-3 pb-6"
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      <div className="flex min-h-[200px] w-full flex-col justify-center gap-4 text-base text-white">
        <p data-a="1" style={{ opacity: 0 }}>
          {m.pro_user_appreciation_letter_gratitude_body1()}
        </p>
        <p data-a="2" style={{ opacity: 0 }}>
          {m.pro_user_appreciation_letter_gratitude_body2()}
        </p>
        <p data-a="3" style={{ opacity: 0 }}>
          {m.pro_user_appreciation_letter_gratitude_body3()}
        </p>
      </div>
      <div
        data-a="4"
        style={{ opacity: 0 }}
        className="flex w-full max-w-[420px] items-center gap-2 rounded-[20px] bg-white/[0.14] py-3 pl-4 pr-3"
      >
        <div className="rounded-[6px] border border-white bg-[linear-gradient(to_right,#8BCC82_0%,#60A983_100%)] px-[6px] text-[9px] font-bold text-white">
          {m.pro()}
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <p className="text-sm text-white">{m.pro_user_include_title()}</p>
          <ul className="list-disc text-sm text-white">
            <li className="ms-[21px]">{m.pro_user_include_content1()}</li>
            <li className="ms-[21px]">{m.pro_user_include_content2()}</li>
          </ul>
        </div>
      </div>
    </motion.div>
  )
}
